Inputmask.extendAliases({
  xphone: {
    mask: "+370 9 999 9999",
    showMaskOnHover: false,
    showMaskOnFocus: true,
    placeholder: ""
  },
  person_code: {
    mask: "99999999999",
    showMaskOnHover: false,
    showMaskOnFocus: false,
    placeholder: ""
  },
  declaration_period: {
    regex: "[0-9]{4}-(0[1-9]|1[012])",
    showMaskOnHover: false,
    showMaskOnFocus: false,
    placeholder: ""
  },
  above_zero: {
    regex: "^[1-9][0-9]*$",
    showMaskOnHover: false,
    showMaskOnFocus: false,
    placeholder: ""
  },
  code: {
    mask: "999999999",
    showMaskOnHover: false,
    showMaskOnFocus: false,
    placeholder: ""
  },
});
/*
$(document).ready(function(){
    $(".inputmask, [data-inputmask], [data-inputmask-mask], [data-inputmask-alias]").each(function(ndx, lmnt){
      void 0 === lmnt.inputmask && Inputmask().mask(lmnt);
    });
});
*/